import React, { useState, useEffect } from 'react';
import './Hero.css';
// Hero images
import gardenMedium from '../../assets/images/hero/garden-M.jpg';
import gardenLarge from '../../assets/images/hero/garden-L.jpg';
import gardenXL from '../../assets/images/hero/garden-XL.jpg';

import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="hero">
      <ResponsiveImage 
        images={{
          small: gardenMedium,
          medium: gardenLarge,
          large: gardenXL
        }}
        alt="Jardin paysagé"
        className="hero-bg"
        loading="eager"
      />
      <div className="hero-overlay"></div>
      <div className="hero-nature-effects">
        {/* Feuilles flottantes */}
        <div className="floating-leaves">
          <div className="leaf leaf-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-leaf-icon lucide-leaf"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg></div>
          <div className="leaf leaf-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-flower-icon lucide-flower"><circle cx="12" cy="12" r="3"/><path d="M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5"/><path d="M12 7.5V9"/><path d="M7.5 12H9"/><path d="M16.5 12H15"/><path d="M12 16.5V15"/><path d="m8 8 1.88 1.88"/><path d="M14.12 9.88 16 8"/><path d="m8 16 1.88-1.88"/><path d="M14.12 14.12 16 16"/></svg></div>
          <div className="leaf leaf-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clover-icon lucide-clover"><path d="M16.17 7.83 2 22"/><path d="M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12"/><path d="m7.83 7.83 8.34 8.34"/></svg></div>
          <div className="leaf leaf-4"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-leafy-green-icon lucide-leafy-green"><path d="M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22"/><path d="M2 22 17 7"/></svg></div>
        </div>
        
        {/* Pétales qui dansent */}
        <div className="dancing-petals">
          <div className="petal petal-1"></div>
          <div className="petal petal-2"></div>
          <div className="petal petal-3"></div>
          <div className="petal petal-4"></div>
          <div className="petal petal-5"></div>
        </div>
        
        {/* Lucioles scintillantes */}
        <div className="fireflies">
          <div className="firefly firefly-1"></div>
          <div className="firefly firefly-2"></div>
          <div className="firefly firefly-3"></div>
          <div className="firefly firefly-4"></div>
          <div className="firefly firefly-5"></div>
          <div className="firefly firefly-6"></div>
        </div>
        
        {/* Branches qui poussent */}
        <div className="growing-branches">
          <svg className="branch branch-left" viewBox="0 0 200 400">
            <path className="branch-path" d="M10,400 Q30,300 50,200 Q70,100 90,0" stroke="rgba(255,255,255,0.1)" strokeWidth="2" fill="none"/>
            <circle className="leaf-bud leaf-bud-1" cx="30" cy="320" r="9" fill="rgba(255,255,255,0.15)"/>
            <circle className="leaf-bud leaf-bud-2" cx="50" cy="220" r="8" fill="rgba(255,255,255,0.15)"/>
            <circle className="leaf-bud leaf-bud-3" cx="70" cy="120" r="7" fill="rgba(255,255,255,0.15)"/>
          </svg>
          
          <svg className="branch branch-right" viewBox="0 0 200 400">
            <path className="branch-path" d="M190,400 Q170,300 150,200 Q130,100 110,0" stroke="rgba(255,255,255,0.1)" strokeWidth="2" fill="none"/>
            <circle className="leaf-bud leaf-bud-1" cx="170" cy="310" r="9" fill="rgba(255,255,255,0.15)"/>
            <circle className="leaf-bud leaf-bud-2" cx="150" cy="230" r="8" fill="rgba(255,255,255,0.15)"/>
            <circle className="leaf-bud leaf-bud-3" cx="130" cy="140" r="7" fill="rgba(255,255,255,0.15)"/>
          </svg>
        </div>
      </div>
      
      <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
        <h2 className="hero-title">
          <span className="title-line">Gardien de votre</span>
          <span className="title-highlight">havre de verdure</span>
        </h2>
        
        <p className="hero-description">
          Saison après saison, nous veillons sur votre jardin comme sur un trésor vivant.
          <br />
          Tonte douce, taille soignée, nettoyage délicat… chaque geste nourrit la beauté
          et l’harmonie de vos espaces verts.
          <br />
          <span className="subtitle">Offrez à votre nature le soin qu’elle mérite</span>
        </p>
      </div>
    </section>
  );
};

export default Hero;